import { render, staticRenderFns } from "./flexbox.vue?vue&type=template&id=f313af88"
import script from "./flexbox.vue?vue&type=script&lang=js"
export * from "./flexbox.vue?vue&type=script&lang=js"
import style0 from "./flexbox.vue?vue&type=style&index=0&id=f313af88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./flexbox.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports